const TicketingPage = () => {
  return null
}

export default TicketingPage
